import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { storageUtil } from 'src/app/utils';
import { BrowserService } from 'src/app/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private isLoggedIn$: BehaviorSubject<boolean>;
  private customEvent$: BehaviorSubject<string> = new BehaviorSubject<any>(null);
  private veteranInfo$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  user$ = new BehaviorSubject<any>({});
  inboxCount$ = new BehaviorSubject<any>({});

  get currentLoginStatus$() {
    return this.isLoggedIn$.asObservable();
  }

  constructor(
    private _storageUtil: storageUtil,
    private _browserService: BrowserService,
  ) {
    // Initialize login status from storage
    const isLoggedIn = this.checkLoginStatusFromStorage();
    this.isLoggedIn$ = new BehaviorSubject<boolean>(isLoggedIn);
  }

  private checkLoginStatusFromStorage(): boolean {
    if (this._browserService.checkBrowser()) {
      const loggedInUser = this._storageUtil.getItem('loggedInUser');
      return !!loggedInUser;
    }
    return false;
  }

  setIsLogin(status: boolean) {
    this.isLoggedIn$.next(status);
  }

  setUser(user: any) {
    this.user$.next(user);
  }

  setInboxCount(count: number) {
    this.inboxCount$.next(count);
  }

  setVeteranInfo(veteranInfo: any) {
    this.veteranInfo$.next(veteranInfo);
  }

  setCustomEvent(event: string) {
    this.customEvent$.next(event);
  }

  get currentVeteranInfo$() {
    return this.veteranInfo$.asObservable();
  }

  get customEventData$() {
    return this.customEvent$
      .pipe(
        filter((event: string, index: number) => !!event)
      );
  }
}
